const initialState = {
  data: null,
};

const logDeliveryLittleReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_LOG_DELIVERY_LITTLE": {
      return {
        data: action.payload,
      };
    }

    case "PUSH_BEFORE_LOG_DELIVERY_LITTLE": {
      return {
        data: [action.payload, ...state.data.slice(0, state.data.length - 1)],
      };
    }

    default:
      return state;
  }
};

export default logDeliveryLittleReducer;
